const endpointsByType = {
    'App\\Models\\Contact': 'contacts',
    'App\\Models\\Business': 'businesses',
};

const typesByEndpoint = {
    contacts: 'App\\Models\\Contact',
    businesses: 'App\\Models\\Business',
};

const labelsByEndpoint = {
    contacts: 'Contact',
    businesses: 'Business',
};

export const ownerEndpoints = ['contacts', 'businesses'];

export const endpointForMorphType = (type) => (type && endpointsByType.hasOwnProperty(type)) ? endpointsByType[type] : null;

export const morphTypeForEndpoint = (endpoint) => (endpoint && typesByEndpoint.hasOwnProperty(endpoint)) ? typesByEndpoint[endpoint] : null;

export const morphLabelForEndpoint = (endpoint) => (endpoint && labelsByEndpoint.hasOwnProperty(endpoint)) ? labelsByEndpoint[endpoint] : '';

export const morphLabelForType = (type) => morphLabelForEndpoint(endpointForMorphType(type));
